import api from './client'

// Inventario cíclico con corte por hora (/m/conteo + STOCK → Inventario, Martin 29 oct 2026).
export const conteosStockApi = {
  config: () => api.get('/conteos-stock/config'),
  articulos: (params) => api.get('/conteos-stock/articulos', { params }),
  listar: (params) => api.get('/conteos-stock', { params }),
  ver: (id) => api.get(`/conteos-stock/${id}`),
  // El cálculo contra Presea corre en la cola (~5 s): el POST devuelve el conteo pendiente.
  crear: (datos) => api.post('/conteos-stock', datos),
  recalcular: (id) => api.post(`/conteos-stock/${id}/recalcular`),
}
